import { useState, useEffect } from "react";
import "../Styles/Navbar.css";

const Navbar = () => {
  const [activeSection, setActiveSection] = useState('home');

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['home', 'about', 'research', 'experience'];
      const scrollPosition = window.scrollY + 100; // Offset for navbar height

      sections.forEach(section => {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
          }
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const navbarHeight = 80;
      const elementPosition = element.offsetTop - navbarHeight;
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  };
  
  return (
    <header className="navbar">
      <div className="navbar-container">
        <div className="navbar-brand" onClick={() => scrollToSection('home')}>
          <div className="brand-icon">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2L2 7l10 5 10-5-10-5z" fill="currentColor"/>
              <path d="M2 17l10 5 10-5M2 12l10 5 10-5" stroke="currentColor" strokeWidth="2" fill="none"/>
            </svg>
          </div>
          <span className="brand-text">Tank Neupane</span>
        </div>
        
        <nav className="navbar-nav">
          <a 
            className={`nav-link ${activeSection === 'home' ? 'active' : ''}`} 
            onClick={() => scrollToSection('home')}
            href="#home"
          >
            Home
          </a>
          <a 
            className={`nav-link ${activeSection === 'about' ? 'active' : ''}`} 
            onClick={() => scrollToSection('about')}
            href="#about"
          >
            About
          </a>
          <a 
            className={`nav-link ${activeSection === 'research' ? 'active' : ''}`} 
            onClick={() => scrollToSection('research')}
            href="#research"
          >
            Research
          </a>
          <a 
            className={`nav-link ${activeSection === 'experience' ? 'active' : ''}`} 
            onClick={() => scrollToSection('experience')}
            href="#experience"
          >
            Experience
          </a>
        </nav>
        
        <div className="navbar-actions">
          <a href="https://www.linkedin.com/in/tank-prasad-neupane-27185198/" target="_blank" rel="noopener noreferrer" className="social-link linkedin-link">
            <svg className="social-icon" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
            </svg>
          </a>
          <a href="mailto:tankp.neupane@jgu.edu.in" className="contact-email">
            <svg className="email-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2" fill="none"/>
              <polyline points="22,6 12,13 2,6" stroke="currentColor" strokeWidth="2" fill="none"/>
            </svg>
            tankp.neupane@jgu.edu.in
          </a>
        </div>
      </div>
    </header>
  );
};
export default Navbar;
